import { Link } from 'react-router-dom'
import { api, ROUTES, imgUrl } from './api'
import { useAsync, PageHead, Loading, money, dateFmt, Status, Empty } from './ui'

export default function Overview() {
  const { data, loading } = useAsync(async () => {
    const [p, c, o] = await Promise.allSettled([api.get(ROUTES.products), api.get(ROUTES.categories), api.get(ROUTES.adminOrdersAll)])
    return {
      products: p.status === 'fulfilled' ? p.value : [],
      categories: c.status === 'fulfilled' ? c.value : [],
      orders: o.status === 'fulfilled' ? o.value : null,
    }
  })

  if (loading) return <Loading />
  const { products, categories, orders } = data
  const restock = products.filter((p) => p.stock <= 5).sort((a, b) => a.stock - b.stock).slice(0, 6)
  const live = (orders || []).filter((o) => o.status !== 'Cancelled')
  const revenue = live.reduce((s, o) => s + Number(o.total || 0), 0)
  const processing = (orders || []).filter((o) => o.status === 'Processing').length

  const figures = [
    ['Products', products.length],
    ['Categories', categories.length],
    ['Needs restocking', products.filter((p) => p.stock <= 5).length],
    ['Orders to process', orders ? processing : '-'],
    ['Revenue (excl. cancelled)', orders ? money(revenue) : '-'],
  ]

  return (
    <>
      <PageHead
        title="Overview"
        sub="What needs attention in your store today."
        actions={
          <>
            <Link className="btn" to="/admin/categories">Add category</Link>
            <Link className="btn primary" to="/admin/products">Add product</Link>
          </>
        }
      />

      <dl className="figures">
        {figures.map(([k, v]) => (
          <div key={k}>
            <dt>{k}</dt>
            <dd>{v}</dd>
          </div>
        ))}
      </dl>

      <div className="two-col">
        <section className="panel">
          <h2>Needs restocking</h2>
          {restock.length === 0 ? (
            <Empty title="Everything is well stocked" body="Products with 5 or fewer units appear here." />
          ) : (
            <ul className="rows">
              {restock.map((p) => (
                <li key={p.id}>
                  {p.img ? <img className="thumb" src={imgUrl(p.img)} alt="" /> : <span className="thumb" />}
                  <span className="grow">{p.name}</span>
                  <span className={`badge ${p.stock === 0 ? 'danger' : 'warn'}`}>{p.stock === 0 ? 'Out of stock' : `${p.stock} left`}</span>
                </li>
              ))}
            </ul>
          )}
        </section>

        <section className="panel">
          <h2>Recent orders</h2>
          {!orders ? (
            <p className="muted">Order data needs the admin orders endpoint ({ROUTES.adminOrders}). Once it exists, recent orders show here.</p>
          ) : orders.length === 0 ? (
            <Empty title="No orders yet" />
          ) : (
            <ul className="rows">
              {orders.slice(0, 6).map((o) => (
                <li key={o.id}>
                  <span className="grow">
                    <strong>{o.orderNo}</strong>
                    <span className="muted"> {dateFmt(o.createdAt)}</span>
                  </span>
                  <span>{money(o.total)}</span>
                  <Status value={o.status} />
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </>
  )
}
